<template>
  <v-navigation-drawer
    :value="toggle"
    :clipped="$vuetify.breakpoint.lgAndUp"
    app
    v-if="$auth.isAuthenticated"
  >
    <v-list data-cy-nav dense>
      <v-list-item-group v-model="item">
        <v-list-item
          v-for="(item, i) in items"
          :key="i"
          :to="item.path"
          class="pl-5"
        >
          <v-list-item-action class="mr-5">
            <v-icon color="primary">{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="subtitle-1 font-weight-bold">{{
              item.text
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "NavMenu",
  data: () => ({
    drawer: false,
    item: 0,
    items: [
      { icon: "notifications_active", text: "Reminders", path: "reminders" },
      { icon: "account_circle", text: "Customers", path: "customers" },
      {
        icon: "person_add_disabled",
        text: "Excluded Customers",
        path: "excluded-customers",
      },
      { icon: "layers", text: "Groups", path: "groups" },
      { icon: "library_books", text: "Templates", path: "templates" },
      {
        icon: "library_books",
        text: "Assign Templates",
        path: "assign-templates",
      },
      {
        icon: "library_books",
        text: "Letter Templates",
        path: "letter-templates",
      },
      {
        icon: "send",
        text: "Send Letters",
        path: "send-letters",
      },
      { icon: "list_alt", text: "Audit Logs", path: "audit-logs" },
      { icon: "list_alt", text: "Dispute", path: "dispute" },
      { icon: "list_alt", text: "Early Termination Fee (ETF)", path: "early-termination-fee" },
    ],
  }),
  watch: {
    allFlags: {
      handler() {
        let vm = this;
        if (!vm.allFlags.SOG4289){
          vm.items = vm.items.filter((x) => x.path != 'early-termination-fee')
        }
        if (!vm.allFlags.SOG3287 || !vm.allFlags.SOG4289) {
          vm.items = vm.items.filter(
            (x) => x.text !== "Letter Templates" && x.text !== "Send Letters"
          );
        }

      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters("menu", ["toggle"]),
  },
};
</script>

<style lang="scss">
.v-list-item--active {
  pointer-events: none;
}
</style>
